/* ============================================================
   MP FEATURED AUDIO — custom player (play/pause, seek, mute)
   Ref Framer: HFPxE7CDk (page /details-featured)
   Scope: .mp-faudio per section (aman untuk >1 instance).
   ============================================================ */
(() => {
  const fmt = (sec) => {
    if (!isFinite(sec) || sec < 0) sec = 0;
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return `${m}:${String(s).padStart(2, "0")}`;
  };

  const setBar = (bar, ratio) => {
    if (!bar) return;
    const p = Math.max(0, Math.min(1, ratio || 0));
    bar.style.setProperty("--p", p);
  };

  const init = (root) => {
    // File ini ikut ter-render ulang tiap instance section (4x di page.featured),
    // jadi init() bisa dipanggil berkali-kali untuk root yang sama. Guard ini
    // mencegah listener klik terpasang ganda: play() akan langsung dibalik
    // pause() oleh listener berikutnya sehingga tombol tampak tidak merespons.
    if (root.dataset.mpFaudioReady === "true") return;
    root.dataset.mpFaudioReady = "true";

    const player = root.querySelector(".mp-faudio__player");
    const audio = root.querySelector(".mp-faudio__audio");
    const toggle = root.querySelector(".mp-faudio__toggle");
    const currentEl = root.querySelector(".mp-faudio__current");
    const durationEl = root.querySelector(".mp-faudio__duration");
    const seekBar = root.querySelector(".mp-faudio__bar--seek");
    const seekRange = seekBar && seekBar.querySelector(".mp-faudio__range");
    const mute = root.querySelector(".mp-faudio__mute");

    if (!player || !audio) return;

    const hasSrc = () => Boolean(audio.currentSrc || audio.src);

    if (!hasSrc()) player.dataset.empty = "true";

    const volume = parseFloat(audio.dataset.volume || "0.25");
    if (!Number.isNaN(volume)) audio.volume = Math.max(0, Math.min(1, volume));

    const syncPlaying = () => {
      const playing = !audio.paused && !audio.ended;
      root.classList.toggle("is-playing", playing);
      if (toggle) {
        toggle.setAttribute("aria-pressed", playing ? "true" : "false");
        toggle.setAttribute("aria-label", playing ? "Jeda audio" : "Putar audio");
      }
    };

    const syncMute = () => {
      const muted = audio.muted || audio.volume === 0;
      root.classList.toggle("is-muted", muted);
      if (mute) {
        mute.setAttribute("aria-pressed", muted ? "true" : "false");
        mute.setAttribute("aria-label", muted ? "Nyalakan suara" : "Matikan suara");
      }
    };

    const syncTime = () => {
      if (currentEl) currentEl.textContent = fmt(audio.currentTime);
      const d = audio.duration;
      if (durationEl) durationEl.textContent = fmt(d);
      setBar(seekBar, d ? audio.currentTime / d : 0);
      if (seekRange && d && document.activeElement !== seekRange) {
        seekRange.value = Math.round((audio.currentTime / d) * 1000);
      }
    };

    if (toggle) {
      toggle.addEventListener("click", () => {
        if (!hasSrc()) return;
        if (audio.paused || audio.ended) {
          const play = audio.play();
          if (play && typeof play.catch === "function") {
            play.catch((err) => console.warn("[mp-featured-audio] play failed:", err));
          }
        } else {
          audio.pause();
        }
      });
    }

    if (seekRange) {
      seekRange.addEventListener("input", () => {
        const d = audio.duration;
        if (!d || !isFinite(d)) return;
        const ratio = Number(seekRange.value) / 1000;
        audio.currentTime = ratio * d;
        setBar(seekBar, ratio);
        if (currentEl) currentEl.textContent = fmt(audio.currentTime);
      });
    }

    if (mute) {
      mute.addEventListener("click", () => {
        audio.muted = !audio.muted;
        syncMute();
      });
    }

    audio.addEventListener("play", syncPlaying);
    audio.addEventListener("pause", () => {
      syncPlaying();
      syncTime();
    });
    audio.addEventListener("ended", () => {
      syncPlaying();
      if (!audio.loop) {
        audio.currentTime = 0;
        syncTime();
      }
    });
    audio.addEventListener("loadedmetadata", syncTime);
    audio.addEventListener("durationchange", syncTime);
    audio.addEventListener("timeupdate", syncTime);
    audio.addEventListener("volumechange", syncMute);
    audio.addEventListener("error", () => {
      player.dataset.empty = "true";
    });

    syncPlaying();
    syncMute();
    syncTime();
  };

  const start = () => {
    document.querySelectorAll(".mp-faudio").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
